import { render, staticRenderFns } from "./withdrawRecord.vue?vue&type=template&id=c1d3c344&scoped=true"
import script from "./withdrawRecord.vue?vue&type=script&lang=js"
export * from "./withdrawRecord.vue?vue&type=script&lang=js"
import style0 from "./withdrawRecord.vue?vue&type=style&index=0&id=c1d3c344&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d3c344",
  null
  
)

export default component.exports